import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setError("Inserisci un'email valida"); return; }
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Invio non riuscito, riprova più tardi");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16">
      <Link to="/login" className="text-sm text-slate-500 hover:text-navy flex items-center gap-1 mb-6"><ArrowLeft className="w-4 h-4" />Torna all'accesso</Link>
      <span className="overline text-gold">Recupero password</span>
      <h1 className="font-display text-3xl font-bold mt-2 mb-3">Password dimenticata?</h1>
      {sent ? (
        <div className="card-premium p-6" data-testid="forgot-sent">
          <Mail className="w-8 h-8 text-gold mb-3" />
          <p className="text-slate-700">Se l'email <strong>{email}</strong> è registrata, riceverai a breve un link per impostare una nuova password. Il link è valido 1 ora.</p>
          <p className="text-xs text-slate-500 mt-3">Controlla anche la cartella spam.</p>
        </div>
      ) : (
        <form onSubmit={submit} noValidate className="space-y-4">
          <p className="text-slate-600">Inserisci l'email con cui ti sei iscritto: ti invieremo un link per reimpostarla.</p>
          <div>
            <label className="overline text-slate-500 mb-2 block">Email</label>
            <input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={`w-full border border-slate-300 rounded-xl px-4 py-3 focus:outline-none focus:border-gold ${error ? "field-error" : ""}`} />
            {error && <div className="field-error-text" data-testid="forgot-error">{error}</div>}
          </div>
          <button data-testid="forgot-submit" disabled={loading} className="btn-pill-gold w-full justify-center">{loading ? "Invio…" : "Invia link di recupero"}</button>
        </form>
      )}
    </div>
  );
}
